import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTicket = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-ticket-icon lucide-ticket",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 5v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 17v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 11v2" })
	]
});
export default SvgTicket;
